import { PDF_VIEWER_COPY } from './pdfViewer.copy';
import type { PdfControls } from './pdfControls';

/**
 * The phone's `⋯` menu — the document acts that are not worth a permanent
 * target on a 400px-wide bar.
 *
 * Download, rotate and the fit toggle are each things a reader does once per
 * document if at all, where paging and signing are things they do repeatedly.
 * That is the whole division: frequency, not importance.
 *
 * **Zoom is not in here, and is not anywhere on a phone.** Pinch is the zoom —
 * `apps/web/index.html` leaves user scaling on deliberately and `FieldLayer`'s
 * header records that a second pointer always belongs to the browser. A pair of
 * `−`/`+` buttons would be a worse version of a gesture the reader already has,
 * and the only way to make them feel primary would be to suppress the gesture.
 *
 * Rendered into `ViewerFrame`'s own overflow, which owns the open state, the
 * outside-click close and Escape's precedence over closing the reader. The
 * items follow `ImageViewer`'s convention — a full-width `<button>` whose text
 * *is* its accessible name — with `min-h-11` for a thumb.
 */
const ITEM_CLASS =
  'flex min-h-11 w-full items-center px-3 py-2 text-left text-sm transition-colors hover:bg-elevated disabled:opacity-60';

export function PdfMobileMenu({
  controls,
  documentReady,
}: {
  controls: PdfControls;
  documentReady: boolean;
}) {
  const { onDownload, downloadLabel, downloadBusy, fitMode, toggleFit, rotate } = controls;

  return (
    <>
      {/* First, and not gated on pdf.js — the desktop toolbar's reasoning. */}
      <button type="button" disabled={downloadBusy} onClick={onDownload} className={ITEM_CLASS}>
        {downloadLabel}
      </button>

      {documentReady ? (
        <>
          <button type="button" onClick={rotate} className={ITEM_CLASS}>
            {PDF_VIEWER_COPY.rotate}
          </button>

          <button type="button" onClick={toggleFit} className={ITEM_CLASS}>
            {fitMode === 'width' ? PDF_VIEWER_COPY.zoom.toFitPage : PDF_VIEWER_COPY.zoom.toFitWidth}
          </button>
        </>
      ) : null}
    </>
  );
}
